import { useRouteError } from 'react-router-dom';

export function ErrorFallback() {
	const error = useRouteError();
	const safeError = error?.error || error || new Error('Unknown error occurred');

	// Extract error details
	const errorCode = safeError.response?.status || 'ERR';
	const errorMessage = safeError.message || 'Something went wrong';
	const errorDetails = safeError.response?.data?.message || safeError.stack;
	const isDev = import.meta.env.MODE === 'development';

	return (
		<div className='flex items-center justify-center min-h-screen p-4 bg-gradient-to-br from-blue-50 to-bd-bg'>
			<div className='w-full max-w-md overflow-hidden bg-white shadow-2xl rounded-xl'>
				{/* Error Header */}
				<div className='p-6 text-white bg-primary'>
					<div className='flex items-center justify-between'>
						<div>
							<h1 className='text-2xl font-bold'>Ups! feil {errorCode}</h1>
							<p className='opacity-90'>vi traff en vanskelig situasjon</p>
						</div>
						<div className='text-5xl'>⚠️</div>
					</div>
				</div>

				{/* Error Content */}
				<div className='p-6 space-y-4'>
					<div className='space-y-2'>
						<h2 className='text-lg font-semibold text-gray-800'>{errorMessage}</h2>
						<p className='text-gray-600'>
							{errorCode === 404
								? "Siden eller ressursen du ba om finnes ikke."
								: 'Prøv igjen eller kontakt kundestøtte hvis problemet vedvarer.'}
						</p>
					</div>

					{/* Technical Details (Dev only) */}
					{isDev && errorDetails && (
						<div className='p-3 mt-4 overflow-auto bg-gray-100 rounded-lg max-h-40'>
							<p className='font-mono text-xs text-gray-700 whitespace-pre-wrap'>
								{typeof errorDetails === 'object' ? JSON.stringify(errorDetails, null, 2) : errorDetails}
							</p>
						</div>
					)}

					{/* Action Buttons */}
					<div className='flex flex-col gap-3 pt-4 sm:flex-row'>
						<button
							onClick={() => window.location.reload()}
							className='flex-1 px-4 py-2 font-medium text-white transition-colors primary rounded-lg'
						>
							↻ Prøv igjen
						</button>
						<a
							href='/'
							className='flex-1 px-4 py-2 font-medium text-center transition-colors border border-gray-300 rounded-lg hover:bg-gray-50'
						>
							🏠 Hjem
						</a>
					</div>
				</div>

				{/* Support Footer */}
				<div className='px-6 py-4 text-sm text-center text-gray-500 bg-gray-50'>
					Need help?{' '}
					<a href='mailto:angga@baezeni.com' className='text-bd-blueLight hover:underline'>
						Contact support
					</a>
				</div>
			</div>
		</div>
	);
}
